<div
  class="contact-module-wrapper"
  [id]="componentId"
  *ngIf="!isLoading; else loadingContactModule"
>
  <h4 *ngIf="headline">{{ headline }}</h4>
  <div
    class="contact-module-row"
    [ngClass]="{
      'col-full': columns === 'col-12',
      'col-half': columns === 'col-6',
    }"
  >
    <div *ngFor="let group of groups || []" class="contact-module-col">
      <p
        class="contact-module-label"
        [ngClass]="{ 'contact-module-no-headline': !headline.trim().length }"
        [innerHTML]="group.label"
      ></p>
      <div class="contact-module-col-item-wrapper">
        <ng-container *ngFor="let item of group.items || []">
          <div
            class="contact-module-col-item"
            [ngClass]="{ 'bg-grey': !isBgWhite }"
            [ngStyle]="isBgWhite ? { 'background-color': backgroundColor } : {}"
          >
            <!-- Render Single Links -->
            <ng-container *ngIf="!item.list; else listLinks">
              <hdi-link
                [hrefType]="
                  item.type === 'external'
                    ? HrefType.EXTERNAL
                    : HrefType.ANGULAR_ROUTE
                "
                [href]="item.href"
                [fragment]="item.fragment ?? ''"
                [target]="item.target === 'new' ? '_blank' : '_self'"
                [title]="item.title ?? ''"
                [label]="item.linkText | capitalize"
              >
                <hdi-icon
                  [iconName]="item.icon"
                  [iconPrefix]="'far'"
                ></hdi-icon>
              </hdi-link>
            </ng-container>

            <!-- Render Link Lists -->
            <ng-template #listLinks>
              <hdi-link
                [hrefType]="HrefType.EXTERNAL"
                [href]="item.href"
                [fragment]="item.fragment ?? ''"
                [target]="'_self'"
                [title]="item.title ?? ''"
                [label]="item.linkText | capitalize"
                (click)="openModal($event, item)"
                [iconName]="item.icon"
                [iconPrefix]="'far'"
                (keydown)="openModal($event, item)"
              >
              </hdi-link>
              <div *ngIf="item.count" class="counter-bubble">
                +{{ item.count }}
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <hdi-modal [showModal]="showModal" (closeModalTrigger)="showModal = $event">
    <div class="header-content">
      <h5>{{ modalContactItem.modalTitle }}</h5>
    </div>
    <div>
      <ng-container *ngFor="let item of modalContactItem.list; let i = index">
        <hdi-link
          class="modal-link"
          [href]="item.href ?? ''"
          [hrefType]="
            item.type === 'external'
              ? HrefType.EXTERNAL
              : HrefType.ANGULAR_ROUTE
          "
          [fragment]="item.fragment ?? ''"
          [target]="item.target === 'new' ? '_blank' : '_self'"
          [title]="item.title ?? ''"
          [label]="item.linkText ?? '' | capitalize"
          [overLabel]="item.linkLabel ?? '' | capitalize"
          [inModal]="true"
        ></hdi-link>
      </ng-container>
    </div>
  </hdi-modal>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingContactModule>
  <div class="contact-module-wrapper">
    <div class="contact-module-row col-half">
      <div *ngFor="let group of [].constructor(4)" class="contact-module-col">
        <div class="contact-module-label">
          <div class="strong-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="hours-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
        <div
          class="contact-module-col-item-wrapper contact-module-col-item-wrapper--loader"
        >
          <div
            class="contact-module-col-item contact-module-col-item--loader"
            *ngFor="let item of [].constructor(2)"
          >
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
